const KpiSummary = () => {
    return (
        <div className="h-full p-4 bg-green-50 rounded shadow">
            <h4>📊 KPI Özeti</h4>
            <p>Bu ay: 85% hedef gerçekleşme</p>
        </div>
    );
};

export default KpiSummary;
